<template>
  <div class="hello">
     <div class="center">
    <el-form :inline="true" :model="gameOptions" v-if="!isStarted">
    <div class="center">
        <el-form-item label="Width:">
            <el-select v-model="gameOptions.width">
                <el-option v-for="n in 10" :key="n" :value="n+4" :label="n+4"></el-option>
            </el-select>
        </el-form-item>
    </div>
    <div class="center">
        <el-form-item label="Height:">
            <el-select v-model="gameOptions.height">
                <el-option v-for="n in 10" :key="n" :value="n+4" :label="n+4"></el-option>
            </el-select>
        </el-form-item>
    </div>
    <div class="center">
        <el-form-item label="Walls:">
            <el-select v-model="gameOptions.walls">
                <el-option v-for="n in 10" :key="n" :value="n+4" :label="n+4"></el-option>
            </el-select>
        </el-form-item>
    </div>
    <div class="center">
        <el-form-item label="Number of peaches:">
            <el-select v-model="gameOptions.numberOfPeaches">
                <el-option v-for="n in 10" :key="n" :value="n+2" :label="n+2"></el-option>
            </el-select>
        </el-form-item>
    </div>
    <div class="center">
          <el-form-item label="Peaches to win:">
            <el-select v-model="gameOptions.peachesToWin">
                <el-option v-for="n in 10" :key="n" :value="n+2" :label="n+2"></el-option>
            </el-select>
        </el-form-item>
    </div>
        
        <el-form-item>
            <el-button type="primary" @click="startButtonOnClick">Start</el-button>
        </el-form-item>
    </el-form>
</div> 
  <div v-if="isStarted">
       <el-button @click="startFromBeginningButtonOnClick">Replay</el-button>
  </div>
    <table id='Grid' v-if="isStarted">
        <tr v-for="(item, index) in gameGrid.gridIDS" :key="index+'row'">
            <td v-for="(gelem, jidx) in item" :key="index+'-'+jidx" 
                v-bind:class="[getGridClass(index, jidx), getUpdatingClass(index, jidx)]" 
                v-bind:data-pos="gelem.id"
                @mouseenter="moseEnterGridElem(index, jidx)"
                @mouseleave="mouseLeaveGridElem(index, jidx)"
                @click="clickOnGrid(index, jidx)"
            >
            <div class = "center" v-if="gameGrid.isPlayer1InGrid(index, jidx)"><img src="../assets/monkey_king.jpg" height="40px"
    width="40px" > </div>
            <div class="larger center" v-if="gameGrid.isPeachInGrid(index, jidx)">🍑</div>
            </td>
        </tr>
    </table>
    
    <div v-if="isStarted" class="center gameInfo">
        <div v-if="isRuLaiTurn" class="gameInfo">
            <div>
                <div >
                    <img src="../assets/rulai.jpeg" height="80px" width="80px"> 


                    <span class="">⛩️</span>  {{gameGrid.remainWalls}} remain !
                </div>
                    <el-button @click="changeTurn">Enough!</el-button>
            </div>
        </div>
        <div v-if="!isRuLaiTurn" class="center gameInfo">
            <div>
            <span class="player1notation">🐵</span> Used {{gameGrid.step}} steps!
            </div>
            <div>
            <span class="peachNotation">🍑</span> {{gameGrid.peachesToWin}} Peaches to win!
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import {Grid, States, types} from './Grid'
export default {
    name: 'GameGridView',
    data() {
        return {
            gameGrid: new Grid(10, 10, 10),
            GridWidth: 7,
            GridHeight: 7,
            walls: 7,
            numberOfPeaches: 5,
            peachesToWin: 3,
            isStarted: false,
            isRuLaiTurn: true,
            gameOptions: {
                width: 7,
                height: 7,
                walls: 7,
                numberOfPeaches: 5,
                peachesToWin: 3,
            }
        }
    },
    computed: {
        monkeyKingWin() {
            return this.gameGrid.peachesToWin==0;
        }
    },
    watch: {
        monkeyKingWin() {
            if (this.monkeyKingWin==true) {
                alert("MonkeyKing win!")
            }
        }
    },
    methods: {
        startButtonOnClick() {
            let width = parseInt(this.gameOptions.width);
            let height = parseInt(this.gameOptions.height);
            let walls = parseInt(this.gameOptions.walls);
            let numberOfPeaches = parseInt(this.gameOptions.numberOfPeaches);
            let peachesToWin = parseInt(this.gameOptions.peachesToWin);
            this.gameGrid = new Grid(width, height, walls, numberOfPeaches, peachesToWin);
            this.isStarted = true;
        },
        startFromBeginningButtonOnClick() {
            this.isStarted = false;
            this.isRuLaiTurn = true;
        },

        changeTurn(){
            this.isRuLaiTurn = false;
        },
        getGridClass: function (idx, jidx) {
            if (idx % 2 === 1) {
                if (jidx % 2 === 1) {
                    return "slot";
                } else {
                    return "wallPlacementVert";
                }
            } else {
                if (jidx % 2 === 1) {
                    return "wallPlacementHoriz";
                } else {
                    return "crossSpace"
                }
            }
        },
        getUpdatingClass: function (idx, jidx) {
            if (this.gameGrid.gridIDS[idx][jidx].state === States.Hover) {
                return "possibleWall";
            } else if (this.gameGrid.gridIDS[idx][jidx].state === States.P1Block || this.gameGrid.gridIDS[idx][jidx].state === States.P2Block) {
                return "keepWall";
            } 
        },
        moseEnterGridElem: function(idx, jidx) {
            if (!this.gameGrid.canPutOnGridElement(idx, jidx)) {
                return
            }
            this.gameGrid.setNext3Edge(idx, jidx, States.Hover);

        },
        mouseLeaveGridElem: function(idx, jidx) {
            if (this.gameGrid.gridIDS[idx][jidx].type == types.HEDGE || this.gameGrid.gridIDS[idx][jidx].type == types.VEDGE) {
                if (this.gameGrid.gridIDS[idx][jidx].state != States.Hover) {
                    return
                }
                this.gameGrid.setNext3Edge(idx, jidx, States.Normal);
            }
        },

        clickOnGrid(idx, jidx) {
            if (this.monkeyKingWin) {
                return;
            }
            // click on the slot
            if (this.gameGrid.gridIDS[idx][jidx].type === types.SLOT ) {
                if(this.isRuLaiTurn == true){
                    return;
                }
                let row = Math.trunc(idx/2);
                let col = Math.trunc(jidx/2);
                let needTurn = this.gameGrid.moveMonkeyKing(row, col, idx, jidx);
                if(needTurn){
                    this.gameGrid.edges = new Map;
                    // console.log(this.gameGrid.edges);
                    this.isRuLaiTurn = true;
                }
                return;
            }

            // click on the edge
            if (!this.isRuLaiTurn) {
                return;
            }
            this.gameGrid.putEdges(idx, jidx);
            this.gameGrid.remainWalls -= 1;
            if(this.gameGrid.remainWalls==0){
                this.isRuLaiTurn = false;
            }
        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    :root {
        --var-player1-color: #ac1f06;
        --var-peach-color: rgb(177, 159, 25);
    }
</style>

<style scoped>
.player1notation {
    color: var(--var-player1-color);
}
.peachNotation {
    color: var(--var-peach-color);
}

.gameInfo {
    font-size: x-large;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

.larger {
	font-size: x-large;
}
#Grid {
    margin-left: auto;
    margin-right: auto;
}
#Grid td { width: 50px; height: 50px; border: 0px solid black; background: #fff; }
#Grid td.wallPlacementVert,
#Grid td.wallPlacementVert_NOHOVER { width: 11px; border: 0px; background: #697783; }
#Grid td.wallPlacementHoriz,
#Grid td.wallPlacementHoriz_NOHOVER { height: 11px; border: 0px; background: #697783; }     
#Grid td.crossSpace { width: 11px; height: 11px; border: 0px; background: #697783; }
#Grid td.wallPlacementHoriz, #Grid td.wallPlacementVert { cursor: pointer; }
#Grid td.movableGreenSpaces { background: #f3ff6a; }    
/* WALL PLACEMENT */
#Grid td.possibleWall { background: #5f212d; }
#Grid td.keepWall { background: #5f212d; }
#showCompPieces, #showPlayerPieces { margin-top: 5px; }
#showPlayerPieces span, #showCompPieces span { font-size: 17px; font-family: "Arial"; margin-left: 18px; }
#showPlayerPieces span.wallVal, #showCompPieces span.wallVal { margin: 0; font-size: 24px; }
/* PIECES */
.piece1 { border-radius: 50%; width: 39px; height: 39px; background: var(--var-player1-color); margin-left: 5px; border: 1px solid var(--var-player1-color); }
</style>
